import {common_utils} from "../common/common_utils";

function detail_by_token_fish()
{

}

detail_by_token_fish.readDataValue = function(this1, data)
{
    this1.fish = true
    common_utils.readDataValue(this1,data,true,true);
    if(this1.gameid == 1006) {
      this1.boxItem = data.detail.IsOpenTreasureBox
      this1.boxItemId = data.detail.Id
      this1.boxItemWin = data.detail.Award
    }
    if(this1.gameid == 1008) {
      this1.boxItem = data.detail.IsNormalLog
      this1.boxItemId = data.detail.Id
      this1.boxItemWin = data.detail.Award
      if(!this1.boxItem) {
        return
      }
    }

    this1.is_props = data.detail.IsProps
    if (this1.gameid == 1000) {
      if (this1.is_props) {
        this1.fishList = data.detail.Props

        this1.props_level = data.detail.PropsLevel
        this1.props_type = data.detail.PropsType
      } else {
        this1.fishList = data.detail.Hits
      }
    } else {
      if(Array.isArray(data.detail)) {
        this1.fishList = data.detail
      } else {
        this1.fishList = data.detail.Hits
      }
    }

}

export {
  detail_by_token_fish
};




// WEBPACK FOOTER //
// ./src/components/data/detail_by_token_fish.js